import translations from '@/i18n/labels.json'

export default {
  methods: {
    getLabels (language) {
      return !translations[language] ? translations.en : translations[language]
    },
  },
}
